export enum ClinicalTaskType {
  Other = "OTH"
}
